import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-delete-snackbar',
  templateUrl: './delete-snackbar.component.html',
  styleUrls: ['./delete-snackbar.component.scss'],
})
export class DeleteSnackbarComponent {
  constructor(
    public snackbarRef: MatSnackBarRef<DeleteSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { successMessage: string },
  ) {}
}
